import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex w-full fixed bottom-[1.5em] left-0 justify-between items-center" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterActions',
  setup(__props) {

const slots = _useSlots();

// ===================================================================
// Computed
// ===================================================================
// Compute how many slots are provided to determine layout
const activeSlots = computed(() => {
    return {
        start: !!slots.start,
        middle: !!slots.middle,
        end: !!slots.end
    };
});

// ===================================================================
// Getters
// ===================================================================
// Compute the width class based on number of active slots
const getWidthClass = computed(() => {
    const count = Object.values(activeSlots.value).filter(Boolean).length;

    switch (count) {
        case 1: return 'w-full';
        case 2: return 'w-1/2';
        default: return 'w-1/3';
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (slots.start)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([getWidthClass.value, 'py-2 bg-secondary text-white font-medium transition-colors hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500'])
        }, [
          _renderSlot(_ctx.$slots, "start")
        ], 2))
      : _createCommentVNode("", true),
    (slots.middle)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([getWidthClass.value, 'py-2 bg-primary text-white font-medium transition-colors hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500'])
        }, [
          _renderSlot(_ctx.$slots, "middle")
        ], 2))
      : _createCommentVNode("", true),
    (slots.end)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass([getWidthClass.value, 'py-2 bg-green-600 text-white font-medium transition-colors hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500'])
        }, [
          _renderSlot(_ctx.$slots, "end")
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})